export default __webpack_public_path__ + "static/media/psdp.594a5f2c.jpg";